/**
 * Branded gradient "scoreboard" shown at the top of the Dashboard. Gives the
 * admin a gamified feel while keeping the rest clean Polaris. Styles live in
 * src/styles/theme.css (.pf-hero*).
 */
export interface HeroStat {
  num: string;
  label: string;
}

export function DashboardHero({
  title,
  subtitle,
  stats,
}: {
  title: string;
  subtitle: string;
  stats: HeroStat[];
}): JSX.Element {
  return (
    <section className="pf-hero" aria-label="Performance summary">
      <div className="pf-hero-head">
        <span className="pf-hero-badge">🎮 PlayForge</span>
        <h2 className="pf-hero-title">{title}</h2>
        <p className="pf-hero-sub">{subtitle}</p>
      </div>
      <div className="pf-hero-stats">
        {stats.map((s) => (
          <div className="pf-hero-stat" key={s.label}>
            <span className="pf-hero-num">{s.num}</span>
            <span className="pf-hero-lbl">{s.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
